import $ from "cash-dom";
__webpack_public_path__ = webpack_static_url; // eslint-disable-line

require("../css/main.css");

var USAFACTS = {
  common: {
    init: function init() {
      import("./modules/edge").then(function (module) {
        module.default();
      });
      import("./modules/defer").then(function (module) {
        module.default();
      });
      import("./modules/newsletter").then(function (module) {
        module.default();
      });
      import("./modules/header").then(function (module) {
        module.default();
      });
      import("./modules/search").then(function (module) {
        module.default();
      });
      import("./modules/youtube").then(function (module) {
        module.default();
      });
      import("./modules/accordion").then(function (module) {
        module.default();
      });
      import("./modules/sharing").then(function (module) {
        module.default();
      });
      import("./modules/charts").then(function (module) {
        module.default();
      });
      import("./modules/chartExplorer").then(function (module) {
        module.default();
      });
      import("./modules/chartModifiers").then(function (module) {
        module.default();
      });
      import("./modules/anchorScrollSpy").then(function (module) {
        module.default();
      });
      import("./modules/sources-and-footnotes").then(function (module) {
        module.default();
      });
      import("./modules/wagtail-footnotes").then(function (module) {
        module.default();
      });

      if ($(".js-truncate").length) {
        import("./modules/truncate").then(function (module) {
          module.default();
        });
      }

      if ($(".js-chartModal").length) {
        import("./modules/richtextChartPopup").then(function (module) {
          module.default();
        });
      }

      if ($("iframe").length) {
        import("./modules/iframes").then(function (module) {
          module.default();
        });
      }

      if ($(".scrolly-section").length) {
        import("./modules/scrollyTelly").then(function (module) {
          module.default();
        });
      }
    }
  },
  home: {
    init: function init() {
      import("./modules/homepageCallout").then(function (module) {
        module.default();
      });
    }
  },
  annual10k: {
    init: function init() {
      import("./modules/annual10k").then(function (module) {
        module.default();
      });
    }
  },
  sotu: {
    init: function init() {
      import("./modules/sotu").then(function (module) {
        module.default();
      });
      import("./modules/bigpicture").then(function (module) {
        module.default();
      });
    }
  },
  covidRecoveryHub: {
    init: function init() {
      import("./modules/covidRecoveryHub").then(function (module) {
        module.default();
      });
    }
  },
  financeTable: {
    init: function init() {
      import("./modules/tables").then(function (module) {
        module.default();
      });
    }
  }
};
var UTIL = {
  exec: function exec(model, action) {
    var modelAction = action === undefined ? "init" : action;

    if (model !== "" && USAFACTS[model] && typeof USAFACTS[model][modelAction] === "function") {
      USAFACTS[model][modelAction]();
    }
  },
  init: function init() {
    var sitewrap = document.getElementsByTagName("body")[0];
    var model = sitewrap.getAttribute("data-model");
    var action = sitewrap.getAttribute("data-action"); // Calls USAFACTS.common.init()

    UTIL.exec("common"); // Calls USAFACTS.model.init()

    UTIL.exec(model);

    if (action !== undefined) {
      // Calls USAFACTS.model.action()
      UTIL.exec(model, action);
    }
  }
};
document.addEventListener("DOMContentLoaded", function () {
  function windowSizing() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
    document.documentElement.style.setProperty("--innerWidth", "".concat(document.body.clientWidth, "px"));
    document.documentElement.style.setProperty("--scrollbarWidth", "".concat(window.innerWidth - document.body.clientWidth, "px"));
  }

  windowSizing();
  window.addEventListener("resize", function () {
    windowSizing();
  }, {
    passive: true
  });
  UTIL.init();
});